import { useCloudDetailsProvider } from 'features/clouds'
import { Typography } from 'procyon-ui'
import React from 'react'
import { AWSAccount } from './components/AWSAccount'
import { AZUREAccount } from './components/AZUREAccount'
import { GCPAccount } from './components/GCPAccount'
import { PrivateAccount } from './components/PrivateAccount'

const OverviewTab = () => {
  const { cloud, isPrivate } = useCloudDetailsProvider()
  const type = cloud.Spec.Type

  return (
    <div className='flex gap-4'>
      <div className='w-1/2'>
        <div className='flex justify-between items-center'>
          <Typography style={{color: '--color-font-base'}} variant='h4-regular'>Account Information</Typography>
        </div>
        {type === 'AWS' && <AWSAccount />}
        {type === 'GCP' && <GCPAccount />}
        {type === 'AZURE' && <AZUREAccount />}
        {isPrivate && <PrivateAccount />}
      </div>
    </div>
  )
}

export { OverviewTab }
